import { Action } from "redux";
import { DealItem } from "./MenuStoreTypes";

export interface DealState {
    deals?: DealItem[];
    itemSkuToDealSku?: Map<string, string>;
    currentDealSku?: string;
    upgradedFromSku?: string;
    currentPage?: number;
}

const initialState: DealState = {
    deals: undefined,
    itemSkuToDealSku: undefined,
    currentDealSku: undefined,
    upgradedFromSku: undefined,
    currentPage: undefined,
}

interface UpdateDeals {
    type: 'UPDATE_DEALS';
    deals: DealItem[];
    itemSkuToDealSku: Map<string, string>;
}

interface UpgradeToDeal {
    type: 'UPGRADE_TO_DEAL';
    upgradedFromSku: string;
    dealSku: string;
}

interface StartDeal {
    type: 'START_DEAL';
    dealSku: string;
}

interface CancelDeal {
    type: 'CANCEL_DEAL';
}

interface SetCurrentPage {
    type: 'SET_CURRENT_PAGE';
    page: number;
}

type KnownAction = UpdateDeals | UpgradeToDeal | StartDeal | CancelDeal | SetCurrentPage;

export const actionCreators = {
    updateDeals: (deals: DealItem[]): UpdateDeals => {
        const itemSkuToDealSku = new Map<string, string>();

        deals.forEach((deal) => {
            deal.upgradeFrom.forEach((itemSku) => {
                itemSkuToDealSku.set(itemSku, deal.dealSku);
            });
        });

        return {
            type: 'UPDATE_DEALS',
            deals: deals,
            itemSkuToDealSku: itemSkuToDealSku,
        }
    },

    upgradeToDeal: (upgradedFromSku: string, dealSku: string): UpgradeToDeal => {
        console.log(`Deal: Upgrading from ${upgradedFromSku} to ${dealSku}.`);

        return {
            type: 'UPGRADE_TO_DEAL',
            upgradedFromSku: upgradedFromSku,
            dealSku: dealSku,
        }
    },

    startDeal: (dealSku: string): StartDeal => {
        console.log(`Deal: Starting ${dealSku}.`);

        return {
            type: 'START_DEAL',
            dealSku: dealSku,
        }
    },

    cancelDeal: (): CancelDeal => {
        console.log('Deal: Cancelling...');

        return {
            type: 'CANCEL_DEAL',
        }
    },

    setCurrentPage: (page: number): SetCurrentPage => {
        return {
            type: 'SET_CURRENT_PAGE',
            page,
        }
    }
};

export function reducer(state: DealState = initialState, incomingAction: Action): DealState {
    const action = incomingAction as KnownAction;

    switch (action.type) {
        case 'UPDATE_DEALS': {
            console.log(`Deals: Added ${action.itemSkuToDealSku.size}`);

            return {
                ...state,
                deals: action.deals,
                itemSkuToDealSku: action.itemSkuToDealSku,
            };
        }

        case 'UPGRADE_TO_DEAL': {
            return {
                ...state,
                currentDealSku: action.dealSku,
                upgradedFromSku: action.upgradedFromSku,
                currentPage: 1,
            };
        }

        case 'START_DEAL': {
            return {
                ...state,
                currentDealSku: action.dealSku,
                currentPage: 1,
            };
        }

        case 'CANCEL_DEAL': {
            return {
                ...state,
                currentDealSku: undefined,
                upgradedFromSku: undefined,
            };
        }

        case 'SET_CURRENT_PAGE': {
            return {
                ...state,
                currentPage: action.page,
            }
        }

        default: {
            return {
                ...state,
            };
        }
    }
}
